import { render, staticRenderFns } from "./gb-ant-select-no-limit-cascader.vue?vue&type=template&id=b2c3b2ac&"
import script from "./gb-ant-select-no-limit-cascader.vue?vue&type=script&lang=js&"
export * from "./gb-ant-select-no-limit-cascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports